import * as React from "react";
import { View, StyleSheet } from "react-native";
import EntriesComponent from "./EntriesComponent";

const TabComponent = props => (
  <View style={styles.container}>
    <View style={styles.list}>
      <EntriesComponent
        company={props.company}
        data={props.data}
        currency={props.currency}
        onPressItem={index => props.onClick(index)}
        onLongPressItem={index => props.onLongPress(index)}
        onEndReached={() => props.onEndReached()}
      />
    </View>
    <View style={styles.detail}>{props.children}</View>
  </View>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "row",
    backgroundColor: "#f3f5f9",
  },
  list: {
    width: "36%",
    minWidth: 300,
    paddingTop: 10,
  },
  detail: {
    flex: 1,
    backgroundColor: "#fff",
    borderLeftWidth: 1,
    borderLeftColor: "#e3e8ef",
  },
});

export default TabComponent;
